import type { StudioRuntimeConfig } from "./env.js";

export function clientLinkUrl(config: StudioRuntimeConfig, shellPath: string): string {
  const base = config.clientPortalBaseUrl.trim();
  if (base.length === 0) {
    return shellPath;
  }
  return `${base.replace(/\/$/, "")}${shellPath.startsWith("/") ? shellPath : `/${shellPath}`}`;
}
